/**
 * Why a person was sent to the sign-in page, carried as a query parameter so the page can say so.
 *
 * Only a session the designer could not renew carries a reason. A deliberate sign-out lands on the
 * bare `/login` — the person knows why they are there.
 */
export const SIGN_IN_REASON_PARAM: string = "reason";

export const SESSION_EXPIRED_REASON: string = "session-expired";

export const SESSION_EXPIRED_SIGN_IN_URL: string = `/login?${SIGN_IN_REASON_PARAM}=${SESSION_EXPIRED_REASON}`;
